<template>
    <div class="land-about">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.about_section_title_img + ')'"></div>
            <!-- <h2>{{salesCard.about_second_title}}</h2> -->
            <h2 v-html="salesCard.about_second_title"></h2>
        </div>
        <div class="container">
            <div class="land-about-column-container" :class="'land-about-' + projectNameG">
                <div class="col-right" v-if="!isMobileChecker">
                    <div class="col-img">
                        <img :src="salesCard.about_img" alt="">
                    </div>
                </div>
                <div class="col-left">
                    <div class="section-title" v-if="!isMobileChecker">
                        <h2 v-html="salesCard.about_second_title"></h2>
                    </div>
                    <div class="desc-html" v-html="salesCard.about_desc"></div>
                    <a :href="salesCard.present_file.file" target="_blank"  class="present-link" v-if="salesCard.present_file.file != false && globalLang != 'kz/'">
                        <svgIcon name="pdf" />
                        <p>{{salesCard.about_btn_present}}</p>
                    </a>
                    <a :href="salesCard.present_file.file_kz" target="_blank"  class="present-link" v-if="salesCard.present_file.file_kz != false && globalLang == 'kz/'">
                        <svgIcon name="pdf" />
                        <p>{{salesCard.about_btn_present}}</p>
                    </a>
                    <div class="video-btn" v-if="salesCard.video_init == 'true' && projectNameG != 'riviera-plus'">
                        <a href="#" class="btn-v" v-scroll-to="{el: '#land-video', offset: offsetResponse}">
                            <svgIcon name="video" />
                            <span>{{ salesCard.shablon_btn_video }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-land-about',
        components: {
            svgIcon,
        },
        data () {
            return {
                projectNameG: window.host,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
            offsetResponse: 'loadOffsetResponse',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-about.scss';
    @import '@/styles/components/sales/respond/land-about-respond.scss';
</style>